import { FormValidator, ValidationResult } from '../formField/types/form-validator';

export const MinValidator: (minInclusive: number, errorMessage: string) => FormValidator = (
  minInclusive: number,
  errorMessage: string
) => {
  return async (value: number): Promise<ValidationResult> => {
    if (isNaN(value) || value < minInclusive) {
      return {
        valid: false,
        error: errorMessage,
      };
    }

    return { valid: true };
  };
};
